import React from 'react';
import { SvgIcon } from '@material-ui/core';

const HorizontalIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <g clipPath="url(#clip0_13_74)">
        <path fillRule="evenodd" clipRule="evenodd" d="M15 0L15 30H12.3333L12.3333 1.19213e-07L15 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.7977 25.5894C26.928 25.2678 27 24.9152 27 24.5454V23.3523H25.6667V24.5454C25.6667 24.7328 25.6305 24.9082 25.566 25.0671L26.7977 25.5894ZM27 6.6477L27 5.45452C27 5.08473 26.928 4.73212 26.7977 4.41056L25.566 4.9329C25.6305 5.09179 25.6667 5.26711 25.6667 5.45452V6.64771L27 6.6477ZM22.8333 27.2727H24.3333C24.6949 27.2727 25.0397 27.1991 25.3541 27.0658L24.8434 25.8061C24.688 25.872 24.5166 25.9091 24.3333 25.9091H22.8333V27.2727ZM19.8333 27.2727H16.8333V25.9091H19.8333V27.2727ZM16.8333 2.72725L19.8333 2.72725V4.09089H16.8333V2.72725ZM22.8333 2.72725H24.3333C24.6949 2.72725 25.0397 2.80085 25.3541 2.9342L24.8434 4.19382C24.688 4.12793 24.5166 4.09089 24.3333 4.09089H22.8333V2.72725ZM27 9.03407V11.4204H25.6667V9.03407H27ZM27 13.8068V16.1932H25.6667V13.8068H27ZM27 18.5795V20.9659H25.6667V18.5795H27Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.33333 24.5454L4.33333 5.45452C4.33333 4.70141 4.93029 4.09089 5.66667 4.09089L11 4.09089V2.72725L5.66667 2.72725C4.19391 2.72725 3 3.94829 3 5.45452L3 24.5454C3 26.0517 4.19391 27.2727 5.66667 27.2727H11V25.9091H5.66667C4.93029 25.9091 4.33333 25.2985 4.33333 24.5454Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_13_74">
          <rect width="30" height="30" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default HorizontalIcon;
